import { graphql } from "react-relay";

export const asanaTaskEventQuery = graphql`
  query AsanaTaskEventQuery($orgRelayId: ID!, $externalEventId: String!, $calendarId: String!) {
    org: node(id: $orgRelayId) {
      __typename
      id
      ... on Org {
        primaryOrgCalendar
        forceFetchEventParentErrorable(calendarId: $calendarId, externalEventId: $externalEventId) {
          __typename
          ... on EventParent {
            id
            events {
              id
              eventKey {
                externalEventId
              }
              organizer {
                urnValue
              }
            }
          }
        }
      }
    }
  }
`;
